import React from 'react';
import { withParentSize } from '@visx/responsive';
import OrgTree from './OrgTree';

const Participation = ({ parentWidth, ...props }) => {
  return <OrgTree width={parentWidth} {...props} />;
};

export default withParentSize(Participation);
